import React from "react";
import { useEffect } from "react";
import KategoriItem from "./KategoriItem";

const KategoriList = ({ categoryList }) => {
	useEffect(() => {
		document.title = "LMS M-Knows | Kategori";
	});
	return (
		<section>
			<div className="container">
				<div className="row mb-4">
					<div className="col-lg-8 mx-auto text-center">
						<h2>Fitur di LMS M-Knows</h2>
						<p className="mb-0">Sudah siap Pelatihan di LMS M-Knows?</p>
					</div>
				</div>
				<div className="row g-4">
					{categoryList.map((category, i) => (
						<KategoriItem key={i} category={category} />
					))}
				</div>
			</div>
		</section>
	);
};

export default KategoriList;
